<template>
  <div
    style="max-height: 75vh;
    overflow-y: auto; overflow-x: hidden;"
    id="filter-modal"
    class="mt-4"
  >
    <date-blocks class="mt-4" />
    <v-row class="mx-9">
      <v-autocomplete
        filled
        dense
        :items="groupOptions"
        :label="groupLabel"
        id="filter-group"
        color="secondary"
        v-model="filterParams.group_id"
      ></v-autocomplete>
    </v-row>
    <v-row class="mx-9">
      <v-autocomplete
        filled
        v-if="_tab === 0 && _client.client_name !== 'shark'"
        dense
        :items="filterOptions.ad_schedule"
        label="Ad Schedule"
        color="secondary"
        id="filter-ad"
        v-model="filterParams.adSchedule"
      ></v-autocomplete>
    </v-row>
    <v-row class="mx-9">
      <v-autocomplete
        filled
        dense
        :items="filterOptions.city"
        label="City"
        id="filter-city"
        color="secondary"
        v-model="filterParams.city"
      ></v-autocomplete>
    </v-row>
    <v-row class="mx-9">
      <v-autocomplete
        filled
        v-if="_tab === 0 && _currentClient.client_name != 'shark'"
        dense
        :items="filterOptions.status"
        label="Status"
        color="secondary"
        id="filter-status"
        v-model="filterParams.status"
      ></v-autocomplete>
    </v-row>
    <v-row class="mx-9">
      <v-autocomplete
        filled
        v-if="_tab === 0 && _currentClient.client_name != 'shark'"
        dense
        :items="filterOptions.tripType"
        :label="tripTypeLabel"
        color="secondary"
        id="filter-trip-type"
        v-model="filterParams.trip_type"
      ></v-autocomplete>
    </v-row>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex';
import FilterParams from '@/mixins/FilterParams';
import DateBlocks from './DateBlocks.vue';

export default {
  components: { DateBlocks },
  mixins: [FilterParams],
  methods: {
    ...mapMutations({
      _setFilterOptions: 'filters/setReportsFilterOptions',
    }),
  },
  computed: {
    ...mapGetters({
      _filterOptions: 'filters/getReportsFilterOptions',
      _tab: 'reports/getTab',
      _areas: 'areas/getAreas',
      _currentClient: 'account/getCurrentClient',
    }),
    filterOptions: {
      get() {
        return this._filterOptions;
      },
      set() {
        this._setFilterOptions();
      },
    },
    tripTypeLabel() {
      switch (this._currentClient.uuid) {
        case '4617860c-4690-4a27-835a-1d9d1bfa4624':
          return 'QR Code/Digital Key';
        case '4aa0754b-6e96-4092-bc61-da873d487628':
          return 'Bluetooth/Premium';
        case '66993187-282c-4932-a7c0-153eb0b253a2':
          return 'Trip Type';
        default:
          return 'trip type';
      }
    },
    groupLabel() {
      if (this._client.client_name !== 'shark') {
        return 'Group Name';
      }
      return 'Course Name';
    },
    groupOptions() {
      this.filterOptions.group.map((group) => {
        group.text = group.text
          .toLowerCase()
          .split(' ')
          .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
          .join(' ');
      });
      return this.filterOptions.group;
    },
  },
};
</script>
